module.exports = [
	{
		"id": "30031001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30031001/640/30031001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan met L-Size boiler",
		"textblock_1st_text": "30031001",
		"textblock_2nd_text": "GROHE RED Duo keukenkraan (C uitloop) met L-size boiler en mengventiel om direct warm en kokend heet water te krijgen. Chroom afwerking. Met energie A-label en kinderbeveiliging.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/30031001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30031DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30031DC1/640/30031DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan met L-Size boiler",
		"textblock_1st_text": "30031DC1",
		"textblock_2nd_text": "GROHE RED Duo keukenkraan (C uitloop) met L-size boiler en mengventiel om direct warm en kokend heet water te krijgen. Matte RVS look. Met energie A-label en kinderbeveiliging.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/30031DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30324DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30324DC1/640/30324DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan met L-Size boiler",
		"textblock_1st_text": "30324DC1",
		"textblock_2nd_text": "GROHE RED Duo keukenkraan (L- uitloop) met L-size boiler en mengventiel om direct warm en kokend heet water te krijgen. Matte RVS look. Met energie A-label en kinderbeveiliging.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/30324DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30338001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30338001/640/30338001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "kraan met L-Size boiler",
		"textblock_1st_text": "30338001",
		"textblock_2nd_text": "GROHE RED Mono keukenkraan (L- uitloop) met L-size boiler en mengventiel om direct warm en kokend heet water te krijgen. Chromen afwerking. Met energie A-label en kinderbeveiliging.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/30338001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30338DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30338DC1/640/30338DC1.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "kraan met L-Size boiler",
		"textblock_1st_text": "30338DC1",
		"textblock_2nd_text": "GROHE RED Mono keukenkraan (L- uitloop) met L-size boiler en mengventiel om direct warm en kokend heet water te krijgen. Matte RVS look. Met energie A-label en kinderbeveiliging.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/30338DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-uitloop Starterkit",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gefilterd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge C-uitloop, chroom afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-uitloop Starterkit",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gefilterd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge C-uitloop, roestvrij stalen afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-uitloop Starterkit",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gefilterd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge U-uitloop, chroom afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-uitloop Starterkit",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gefilterd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge U-uitloop, roestvrij stalen afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starterkit",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "GROHE Blue Home Mono Starterkit: keukenkraan voor gefilterd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge C-uitloop, chroom afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Mono Starterkit",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "GROHE Blue Home Mono Starterkit: keukenkraan voor gefilterd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge C-uitloop, roestvrij stalen afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "40438001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40438001/640/40438001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Filter met filterhouder",
		"textblock_1st_text": "40438001",
		"textblock_2nd_text": "GROHE Red filter met filterhouder",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/40438001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G286",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-uitloop Starterkit",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gefilterd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge L-uitloop, chroom afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-uitloop Starterkit",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo Starterkit: eengreeps keukenmengkraan voor gefilterd, gekoeld en bruisend water. Inclusief koeler, filter en CO2 fles. Hoge L-uitloop, roestvrij stalen afwerking.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30144001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30144001/640/30144001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan met L-Size boiler",
		"textblock_1st_text": "30144001",
		"textblock_2nd_text": "GROHE RED Duo keukenkraan (U uitloop) met L-size boiler en mengventiel om direct warm en kokend heet water te krijgen. Chromen afwerking.. Met energie A-label en kinderbeveiliging.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/30144001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30144DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30144DC1/640/30144DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan met L-Size boiler",
		"textblock_1st_text": "30144DC1",
		"textblock_2nd_text": "GROHE RED Duo keukenkraan (U uitloop) met L-size boiler en mengventiel om direct warm en kokend heet water te krijgen. Matte RVS look. Met energie A-label en kinderbeveiliging.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/30144DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30324001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30324001/640/30324001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Kraan met L-Size boiler",
		"textblock_1st_text": "30324001",
		"textblock_2nd_text": "GROHE RED Duo keukenkraan (L- uitloop) met L-size boiler en mengventiel om direct warm en kokend heet water te krijgen. Chromen afwerking. Met energie A-label en kinderbeveiliging.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/30324001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30032DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30032DC1/640/30032DC1.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "kraan met L-Size boiler",
		"textblock_1st_text": "30032DC1",
		"textblock_2nd_text": "GROHE RED Mono keukenkraan (C- uitloop) met L-size boiler en mengventiel om direct warm en kokend heet water te krijgen. Matte RVS look. Met energie A-label en kinderbeveiliging.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/30032DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30032001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30032001/640/30032001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "kraan met L-Size boiler",
		"textblock_1st_text": "30032001",
		"textblock_2nd_text": "GROHE RED Mono keukenkraan (C- uitloop) met L-size boiler en mengventiel om direct warm en kokend heet water te krijgen. Chromen afwerking. Met energie A-label en kinderbeveiliging.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.nl/nl_nl/product/30032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.nl/nl_nl/onze-service/locator.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/water_products_nl_nl.json
// module id = 888
// module chunks = 0